<template>
  <div class="card" :style="cardStyle">
    <div v-if="statusConfig.showMask " class="overlay"></div>

    <div class="card-header">

      <span class="status" :style="{fontSize:statusConfig.fontSize}">{{ session.status }}</span>

      <!--      <div v-if="session.count" class="count-circleBox">-->
      <!--        <span v-if="statusConfig.showTips">剩余</span>-->
      <!--        <span-->
      <!--            class="count-circle"-->
      <!--            :style="{ border: `2px solid ${statusConfig.border}` }"-->
      <!--        >-->
      <!--          {{ session.count }}-->
      <!--        </span>-->
      <!--      </div>-->
      <!--      -->
      <div class="count-circleBox">
        <img class="count-new-icon" src="@/assets/icon_user.png" alt="">
        <span class="count-new-circle">
              {{ session.count }}
            </span>
      </div>
    </div>

    <div
        class="card-body"
        :style="{
        backgroundImage: `url(${statusConfig.currentBgImage})`
    }"
    >
      <div class="time" :style="{fontSize:statusConfig.timeFontSize}">{{ session.time }}</div>

      <div v-if="session.peopleNum" class="people">
        已有{{ session.peopleNum }}人
      </div>
      <div
          v-if="statusConfig.circleBg"
          class="status-circle"
          :style="{
          background: statusConfig.circleBg,
          border: `1px solid ${statusConfig.border}`
        }"
      >
        <span
            class="circle-text"
            :style="{
            color: statusConfig.fontColor,
            fontSize: statusConfig.tipsFontSize
          }"
        >
          {{ statusConfig.circleText || session.status }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "itemDemo",
  props: {
    session: {type: Object, required: true},//场次信息

    width: {type: [String, Number], default: "200px"},//card宽度
  },

  computed: {
    /**
     * 状态样式配置表：
     */
    statusConfig() {
      let fontMap = {
        '4':{
          fontSize:'24px',
          timeFontSize:'34px',
        },
        '6':{
          fontSize:'22px',
          timeFontSize:'32px',
        },
        '8':{
          fontSize:'22px',
          timeFontSize:'28px',
        },
        '10':{
          fontSize:'22px',
          timeFontSize:'28px',
        },
      }
      const map = {
        "可预约": {
          bg: "#A0ED46",
          border: "#427903",
          currentBgImage:require('@/assets/itemCardBodyBk.png'),
          fontSize:fontMap[this.session.number].fontSize || '28px',
          timeFontSize:fontMap[this.session.number].timeFontSize || '28px',
        },
        "可加入": {
          bg: "#FCE029",
          border: "#8F7E0E",
          showTips: true,
          currentBgImage:require('@/assets/itemCardBodyBk1.png'),
          fontSize:fontMap[this.session.number].fontSize || '28px',
          timeFontSize:fontMap[this.session.number].timeFontSize || '28px',
        },
        "已满场": {
          bg: "#A0ED46",
          fontColor: "#3B630B",
          fontSize:fontMap[this.session.number].fontSize,
          border: "#427903",
          circleBg: "rgba(160,237,70,0.5)",
          circleText: "满",
          currentBgImage:require('@/assets/itemCardBodyBk1.png'),
          showMask: true,
          timeFontSize:fontMap[this.session.number].timeFontSize || '28px',
          tipsFontSize:`${24}px`
        },
        "游戏中": {
          bg: "#35E3EF",
          border: "#14585D",
          circleBg: "rgba(53,227,239,0.5)",
          showMask: true,
          currentBgImage:require('@/assets/itemCardBodyBk.png'),
          fontSize:fontMap[this.session.number].fontSize,
          timeFontSize:fontMap[this.session.number].timeFontSize || '28px',
          tipsFontSize:`${14}px`
        },
        "不可选": {
          bg: "#AEAEAE",
          fontColor: "#515151",
          border: "#515151",
          circleBg: "rgba(174,174,174,0.5)",
          showMask: true,
          currentBgImage:require('@/assets/itemCardBodyBk.png'),
          tipsFontSize:`${14}px`,
          timeFontSize:fontMap[this.session.number].timeFontSize || '28px',
        },
      };
      return map[this.session.status] || {};
    },

    /**
     * 卡片的动态样式
     * 根据状态配置和传入的 session 属性动态生成样式。
     */
    cardStyle() {

      return {
        backgroundColor: this.statusConfig.bg, // 状态背景色
        width: this.width + "px",              // 宽度
        height: this.session.len + "px",       // 高度（通常用于甘特条长度）
        ...this.session.style,                 // 可扩展自定义样式
        borderRadius: "8px",
        position: "absolute",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)", // 卡片阴影

      };
    },
  },
};
</script>

<style scoped>
.overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.75);
  border-radius: 8px;
  z-index: 8;
}

.card {
  color: #333;
  overflow: hidden;
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 8;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  padding: 3px 12px;
  font-weight: bold;
}

.status {
  font-size: 16px;
}

.count-circleBox {
  display: flex;
  align-items: center;
}
.count-new-icon{
  width: 20px;
  height: 20px;
}

.count-new-circle{
  width: 25px;
  height: 25px;
  border-radius: 50%;
  color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
}
.count-circle {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #ffffff;
  color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  margin-left: 5px;
}

.card-body {
  position: relative;
  background-color: #ffffff;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right center;
  border-radius: 0 0 6px 6px;
  padding: 12px;
  text-align: center;
  margin: 0 4px 4px 4px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.time {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 6px;
}

.people {
  color: #767676;
  font-weight: bold;
  font-size: 18px;
}

.status-circle {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  transform: rotate(-45deg);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
}

.circle-text {
  font-weight: bold;
  color: #14585D;
}
</style>
